<template>
  <div />
</template>

<script>

/**
 * Vue: Contact form (contact-form)
 * -----------------------------------------------------------------------------
 * Form used on the contact page.
 * - Static section.
 *
 */
export default {
  name: 'ContactForm',

  mounted() {
    this.setNodeSelectors()
    this.setEventListeners()
  },

  methods: {

    /**
     * Set node selectors.
     */
    setNodeSelectors() {
      this.nodeSelectors = {
        form: document.querySelector('[js-form="form"]'),
        fields: document.querySelector('[js-form="fields"]'),
        success: document.querySelector('[js-form="success"]'),
        file: [...document.querySelectorAll('[js-form="file"]')],
      }
    },

    /**
     * Set event listeners.
     */
    setEventListeners() {
      this.nodeSelectors.file.forEach((element) => {
        const input = element.querySelector('[js-file="input"]')
        const label = element.querySelector('[js-file="label"]')

        input.addEventListener('change', () => {
          if (!input.files.length) {
            label.innerText = this.$string('contact.fields.file.label')
            label.classList.add(this.$class('disabled'))
            element.setAttribute('title', '')
            return
          }

          label.classList.remove(this.$class('disabled'))

          if (input.files.length === 1) {
            label.innerText = input.files[0].name
            element.setAttribute('title', '')
          } else {
            label.innerText = `${input.files.length} files`

            const fileNames = [...input.files].map(file => file.name).join('\r\n')
            element.setAttribute('title', fileNames)
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import './contact-form';
</style>
